import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { type AnyChainId } from '@/shared/assets/chains';
import { type Token } from '@/shared/assets/tokens';
import { integrationManager } from '@/shared/integrations';
import { deduplicater } from '@/shared/utils/arrays';

const deduplicateTokens = deduplicater<Token>((t: Token) => t.address.toLowerCase());

export const useTokens = (
  sourceChainId: AnyChainId | undefined,
  type?: 'deposit' | 'destination',
): { tokens: Token[]; isLoading: boolean } => {
  const { data: chainflipTokens, isLoading: chainflipLoading } = useQuery({
    queryKey: ['CHAINFLIP_TOKENS', sourceChainId],
    enabled: Boolean(sourceChainId),
    queryFn: async () =>
      integrationManager.getIntegration('chainflip').getTokens(sourceChainId!, type),
  });

  const tokens = useMemo(() => deduplicateTokens([...(chainflipTokens ?? [])]), [chainflipTokens]);

  return { tokens, isLoading: chainflipLoading };
};
